module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Lock-circle-30f898145b23bb1704e94749edfc9d9a.svg";